import { StyleSheet } from 'react-native';
import { pageContainerStyle } from '../../common.style';

export default StyleSheet.create({
  container: {
    ...pageContainerStyle,
    backgroundColor: '#FFF',
    paddingHorizontal: 16,
    paddingTop: 12,
  },
  header: {
    marginBottom: 16,
  },
  headerTitle: {
    fontSize: 28,
    fontWeight: '700',
    color: '#151A2D',
  },
  profileCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 18,
    padding: 16,
    marginBottom: 22,
    shadowColor: '#000',
    shadowOpacity: 0.06,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 3 },
    elevation: 2,
  },
  avatar: {
    width: 46,
    height: 46,
    borderRadius: 23,
    backgroundColor: '#5B5FEF',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  avatarText: {
    color: '#FFF',
    fontWeight: '700',
  },
  profileText: {
    flex: 1,
  },
  profileName: {
    fontSize: 16,
    fontWeight: '700',
    color: '#151A2D',
  },
  profileRole: {
    marginTop: 2,
    fontSize: 13,
    color: '#7C8196',
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: '700',
    color: '#A0A6B8',
    marginBottom: 10,
    marginTop: 8,
    letterSpacing: 0.8,
  },
  list: {
    marginBottom: 18,
    gap: 12,
  },
  menuCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 18,
    paddingVertical: 14,
    paddingHorizontal: 14,   
    shadowColor: '#000',
    shadowOpacity: 0.05,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 2 },
    elevation: 1,
  },
  iconWrap: {
    width: 40,
    height: 40,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  menuText: {
    flex: 1,
  },
  menuTitle: {
    fontSize: 15,
    fontWeight: '600',
    color: '#151A2D',
  },
  menuSubtitle: {
    marginTop: 2,
    fontSize: 12,
    color: '#8A90A6',
  },
  dangerText: {
    color: '#D64545',
  },
    initialsAvatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
    backgroundColor: '#6366F1',
  },
  initialsAvatarText: {


    color: '#fff',
    fontWeight: '700',
    fontSize: 15,
  },
});